/**
 * CSV export shared by every screen (W1 brick). One escaping rule, a UTF-8
 * BOM so Excel reads accents, and neutralised formula cells: a value that
 * starts with = + - @ (or a tab/CR) would run as a formula in a spreadsheet
 * (CSV injection), so it gets a leading apostrophe. Purely numeric values
 * (negative numbers, E.164 phone numbers like +33 6 12 34 56 78) run
 * nothing and are left alone.
 */
const FORMULA_START = /^[=+\-@\t\r]/;
const NUMERIC = /^[+-]?[\d\s().,]+$/;

export function csvCell(val: unknown): string {
  let str = String(val ?? '');
  if (typeof val !== 'number' && FORMULA_START.test(str) && !NUMERIC.test(str)) str = `'${str}`;
  if (/[",\n\r;]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
  return str;
}

export function toCsv(header: string[], rows: unknown[][]): string {
  return [header, ...rows].map((r) => r.map(csvCell).join(',')).join('\n');
}

/** Starts the browser download of `csv` as `filename`. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoked on the next tick: revoking right after click() can cancel the
  // download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
